import getInLinksPage from "@/pageComponents/inlink";

const Page = getInLinksPage("material");

export default Page.PageComponent;
export const getServerSideProps = Page.getServerSideProps;
